import { render, staticRenderFns } from "./formStaticLabel.vue?vue&type=template&id=64f2d1c6&"
import script from "./formStaticLabel.vue?vue&type=script&lang=js&"
export * from "./formStaticLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports